/**
 * Help center landing page with optional slots for tier-2 customization.
 * Slots: header (above title), extraModules (below default module links).
 */
import Link from 'next/link'
import type { ReactNode } from 'react'

export type HelpPageSlots = {
  /** Content above the main title */
  header?: ReactNode
  /** Additional module links or sections below the default modules */
  extraModules?: ReactNode
}

export type HelpPageProps = {
  slots?: HelpPageSlots
}

const DEFAULT_MODULES = [
  { href: '/help/chat', title: 'Chat Module', description: 'AI-powered chat interface and conversation management' },
  { href: '/help/editor', title: 'Editor Module', description: 'Document editing and workspace management' },
  { href: '/help/core', title: 'Core System', description: 'Shared components, services, and utilities' },
]

export function HelpPage({ slots }: HelpPageProps) {
  return (
    <div className="max-w-4xl mx-auto p-6">
      {slots?.header}
      <h1 className="text-3xl font-bold mb-6">Help Center</h1>
      <div className="grid gap-4">
        {DEFAULT_MODULES.map((m) => (
          <Link
            key={m.href}
            href={m.href}
            className="block p-4 border rounded-lg hover:bg-gray-50 transition-colors"
          >
            <h2 className="text-xl font-semibold mb-2">{m.title}</h2>
            <p className="text-gray-700">{m.description}</p>
          </Link>
        ))}
        {slots?.extraModules}
      </div>
    </div>
  )
}
